import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white' | 'gold';
  size?: 'sm' | 'md' | 'lg';
  icon?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-gradient-brand text-white shadow-lg shadow-magenta/30 hover:shadow-magenta/50 border border-transparent',
    secondary: 'bg-gradient-warm text-white shadow-lg shadow-coral/30 hover:shadow-coral/50 border border-transparent',
    outline: 'bg-transparent border-2 border-magenta text-magenta hover:bg-magenta/5',
    white: 'bg-white text-magenta shadow-lg hover:bg-gray-50',
    gold: 'bg-gradient-to-b from-[#f4c430] via-[#f4c430] to-[#d4a428] text-black shadow-[0_8px_16px_rgba(0,0,0,0.3),0_4px_8px_rgba(244,196,48,0.4)] hover:shadow-[0_10px_20px_rgba(0,0,0,0.4),0_6px_12px_rgba(244,196,48,0.5)] border-t border-[#ffd93d]/50 hover:translate-y-[-2px] active:translate-y-[1px] active:shadow-[0_4px_8px_rgba(0,0,0,0.3)]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    y: -2,
    scale: 1.02
  }} whileTap={{
    y: 0,
    scale: 0.98
  }} className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-338">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-339" />}
    </motion.button>;
}